export default __webpack_public_path__ + "static/applet-15-set-1-311cedbbcb827ef266c685512fcd6234.webp";